import styled from 'styled-components';

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
